import { usePublicApiClient } from '@guiker/react-framework'
import { PublicApiClient } from '@guiker/recommended-listing-api-client'

export const useRecommendedListingApiClient = usePublicApiClient(PublicApiClient)
